<template>
  <div class="YiLouShengXiaoTongJi">

    <!-- 標題 bar -->
    <div class="content-8__titlebar">
      <div class="content-8__titlebar__left">
        <div class="c8-titlename">
          <span class="c8-titlename__text">遗漏生肖统计</span>
        </div>
      </div>
    </div>

    <RadioButtons v-model="code" title="分析选择" :buttons="hmBtns" />
    <RadioButtons v-model="periodCount" title="统计期数" :buttons="periodBtns" />
    <NoData v-if="option.xAxis.data.length === 0 && !isLoading" />
    <div v-else v-loading="isLoading" class="chart-container">
      <v-chart :options="option" />
    </div>
  </div>
</template>
<script>
import { getHmShengXiaoLost } from '@/api/desktop/tongJi'
import RadioButtons from '@/components/web/common/RadioButtons'
import NoData from '@/components/web/common/NoData'

export default {
  name: 'YiLouShengXiaoTongJi',
  components: {
    RadioButtons,
    NoData
  },
  filters: {
    toName(name) {
      switch (name) {
        case 'shengXiao_shu':
          return '鼠'
        case 'shengXiao_niou':
          return '牛'
        case 'shengXiao_hu':
          return '虎'
        case 'shengXiao_tu':
          return '兔'
        case 'shengXiao_long':
          return '龙'
        case 'shengXiao_she':
          return '蛇'
        case 'shengXiao_ma':
          return '马'
        case 'shengXiao_yang':
          return '羊'
        case 'shengXiao_hou':
          return '猴'
        case 'shengXiao_ji':
          return '鸡'
        case 'shengXiao_gou':
          return '狗'
        case 'shengXiao_jhu':
          return '猪'
        default:
          console.error('错误的生肖名称')
          return name
      }
    }
  },
  data() {
    return {
      data: [],
      hmBtns: [
        { name: '正码', val: 'zm' },
        { name: '特码', val: 'tm' }
      ],
      periodBtns: [
        { name: '500', val: '500' },
        { name: '300', val: '300' },
        { name: '100', val: '100' },
        { name: '30', val: '30' }
      ],
      code: 'zm',
      periodCount: '100',
      isLoading: false,
      option: {
        tooltip: {
          trigger: 'axis',
          formatter: (val) => {
            return `<span>生肖 ${val[0].axisValue}： ${val[0].value} 次</span>`
          }
        },
        xAxis: {
          type: 'category',
          data: [],
          nameLocation: 'middle',
          name: '生肖',
          nameTextStyle: {
            fontSize: 24,
            padding: 12,
            height: 4
          },
          axisPointer: {
            type: 'shadow',
            shadowStyle: {
              color: 'rgba(151, 220, 223,0.3)'
            }
          },
          axisTick: {
            inside: true
          }
        },
        yAxis: {
          type: 'value',
          nameRotate: 0,
          nameLocation: 'middle',
          name: '{x|遺\n漏\n次\n数}',
          nameTextStyle: {
            rich: {
              x: {
                fontSize: 24,
                padding: 12,
                color: 'black',
                height: 4
              }
            }
          },
          boundaryGap: [0, '20%'],
          axisTick: {
            show: false
          },
          splitArea: {
            show: true,
            areaStyle: {
              shadowColor: 'rgba(151, 220, 223, 0.5)',
              shadowBlur: 2
            }
          }
        },
        series: [{
          data: [],
          type: 'bar',
          barWidth: 30,
          itemStyle: {
            color: 'rgb(24, 141, 236)'
          }
        }]
      }
    }
  },
  watch: {
    periodCount(newValue) {
      this.getHmShengXiaoLost(this.code, newValue)
    },
    code(val) {
      this.getHmShengXiaoLost(val, this.periodCount)
    }
  },
  created() {
    this.getHmShengXiaoLost('zm', '100')
  },
  methods: {
    async getHmShengXiaoLost(field, count) {
      this.isLoading = true
      const [data, error] = await getHmShengXiaoLost({
        code: this.$route.params.lottery_code, // 代號
        field: field, // zm(正碼) tm(特碼)
        count: count, // 期的數量
        orderColumn: 'count' // 排序 nmu, count
      })
      this.isLoading = false
      if (error) {
        console.error(`[error]:`, error)
        return
      }
      this.option.xAxis.data = data.map(item => this.$options.filters.toName(item.ruleCode))
      this.option.series[0].data = data.map(item => item.count)
    }
  }
}
</script>

<style lang="scss" scoped>
.YiLouShengXiaoTongJi {
  width: 100%;
  height: 700px;
  background-color: white;
}

.chart-container {
  height: 600px;
}

.echarts {
  width: 100%;
  height: 80% !important;
}
</style>

